/* global axios */

import ApiClient from './ApiClient';

class BrasilApiAPI extends ApiClient {
  constructor() {
    super('brasil_api', { accountScoped: true });
  }

  consultar(document) {
    return axios.post(`${this.url}/consultar`, { document });
  }
}

export default new BrasilApiAPI();
